import { AxiosError, AxiosResponse } from 'axios';
import instance, { ApiError } from '../../api/instance';
import { CompanyParameters, CompanyParametersRecord } from 'src/features/companyParameters/companyParameters.types';

const companyBannersApiPath = (companyId: string) => `/companies/${companyId}/parameters`;

export const getCompanyParameters = async ({
  companyId,
}: {
  companyId: string;
}): Promise<AxiosResponse<CompanyParameters & ApiError>> => {
  return instance
    .get<CompanyParameters>(companyBannersApiPath(companyId))
    .catch(e => e.response as AxiosError<ApiError> as never);
};

const companyCheckinsApiPath = (companyId: string) => `/companies/${companyId}/parameters/checkins`;

export const createCompanyCheckinRecord = async ({
  companyId,
  data,
}: {
  companyId: string;
  data: Partial<CompanyParametersRecord>;
}): Promise<AxiosResponse<CompanyParametersRecord & ApiError>> => {
  return instance
    .post<CompanyParametersRecord>(companyCheckinsApiPath(companyId), data)
    .catch(e => e.response as AxiosError<ApiError> as never);
};

const companyHeadsetsNumberApiPath = (companyId: string) => `/companies/${companyId}/parameters/working_devices`;

export const createCompanyHeadsetsNumberRecord = async ({
  companyId,
  data,
}: {
  companyId: string;
  data: Partial<CompanyParametersRecord>;
}): Promise<AxiosResponse<CompanyParametersRecord & ApiError>> => {
  return instance
    .post<CompanyParametersRecord>(companyHeadsetsNumberApiPath(companyId), data)
    .catch(e => e.response as AxiosError<ApiError> as never);
};

const companyCheckinRecordApiPath = (companyId: string, recordId: string) =>
  `/companies/${companyId}/parameters/checkins/${recordId}`;

export const updateCompanyCheckinRecord = async ({
  companyId,
  recordId,
  data,
}: {
  companyId: string;
  recordId: string;
  data: Partial<Omit<CompanyParametersRecord, 'id'>>;
}): Promise<AxiosResponse<CompanyParametersRecord & ApiError>> => {
  return instance
    .post<CompanyParametersRecord>(companyCheckinRecordApiPath(companyId, recordId), data)
    .catch(e => e.response as AxiosError<ApiError> as never);
};

export const deleteCompanyCheckinRecord = async ({
  companyId,
  recordId,
}: {
  companyId: string;
  recordId: string;
}): Promise<AxiosResponse<void & ApiError>> => {
  return instance
    .delete(companyCheckinRecordApiPath(companyId, recordId))
    .catch(e => e.response as AxiosError<ApiError> as never);
};

const companyHeadsetsNumberRecordApiPath = (companyId: string, recordId: string) =>
  `/companies/${companyId}/parameters/working_devices/${recordId}`;

export const updateCompanyHeadsetsNumberRecord = async ({
  companyId,
  recordId,
  data,
}: {
  companyId: string;
  recordId: string;
  data: Partial<Omit<CompanyParametersRecord, 'id'>>;
}): Promise<AxiosResponse<CompanyParametersRecord & ApiError>> => {
  return instance
    .post<CompanyParametersRecord>(companyHeadsetsNumberRecordApiPath(companyId, recordId), data)
    .catch(e => e.response as AxiosError<ApiError> as never);
};

export const deleteCompanyHeadsetsNumberRecord = async ({
  companyId,
  recordId,
}: {
  companyId: string;
  recordId: string;
}): Promise<AxiosResponse<void & ApiError>> => {
  return instance
    .delete(companyHeadsetsNumberRecordApiPath(companyId, recordId))
    .catch(e => e.response as AxiosError<ApiError> as never);
};
